<div class="p-grid ctx-bottom-gutter" *ngIf="title">
  <h2 class="p-col-12 mu-header-5" translate>{{ title }}</h2>
</div>
<div
  class="p-grid p-col-12 {{ contentClass }} p-md-{{ gridSizeForm }} mu-form-content {{ scrollable ? 'mu-form-scrollable' : '' }} {{
    withAbsoluteButtons ? 'mu-form-content-with-absolute-buttons' : ''
  }}"
>
  <ng-content></ng-content>
</div>
